import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    iconStyle: {
      color: palette.deepBlue,
      fontSize: 22,
    },

    content: {
      marginTop: '32px',
    },

    cardsContent: {
      flex: 1,
      padding: '8px 24px 16px',
    },
    qrCodeWrapper: {
      position: 'relative',
      width: 200,
      height: 200,
      border: `1px solid rgba(0,0,0,0.15)`,
      borderRadius: 4,
      margin: '0 0 24px 0',
      paddingBottom: 8,
      overflow: 'hidden',
      fontFamily: 'Roboto',

      '& img': {
        width: '100%',
        height: '100%',
        borderRadius: 4,
      },

      '& figcaption': {
        position: 'absolute',
        bottom: 12,
        left: 0,
        width: '100%',
        textAlign: 'center',
        fontSize: 12,
      },

      '& .qrCodeButton': {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none',
        background: 'rgba(0,0,0,0.3)',
        cursor: 'pointer',
        opacity: 0,
        transition: 'opacity 0.3s',

        '&:after': {
          content: 'attr(data-copy-text)',
          background: palette.white,
          padding: '8px 12px',
          borderRadius: 4,
          fontSize: 14,
        },
      },

      '& .qrCodeButton:focus': {
        background: 'rgba(0, 128, 0, .5)',
        opacity: 1,

        '&:after': {
          content: 'attr(data-copied-text)',
          color: 'rgb(0, 128, 0)',
        },
      },

      '&:hover .qrCodeButton': {
        opacity: 1,
      },
    },
    buttons: {
      margin: '20px auto',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },
  });
